/**
 * FNV-1a, 32-bit, over the UTF-8 bytes of a string: eight lowercase hex
 * digits, the same on every client with no coordination.
 *
 * For DOCUMENT IDS derived from text, where the text itself must not be
 * in the id (a "/" splits a document path) but the id must still be
 * stable - a retried write has to land on the same document. Not a
 * cryptographic hash, and not meant to be: 32 bits is plenty when the
 * id also carries a timestamp.
 *
 * Changing it changes every id ever derived with it (the map library's
 * long names, the narrative log), so the published vectors are pinned in
 * its test.
 */
export function fnv1aHex(s: string): string {
  let h = 0x811c9dc5;
  for (const b of new TextEncoder().encode(s)) {
    h ^= b;
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, '0');
}
